import { useState, useEffect } from 'react';
import { APP_VERSION } from '../changelog/changelog';

const STORAGE_KEY = 'wt_changelog_seen_version';

/**
 * Hook zur Steuerung der Changelog-Modal-Sichtbarkeit.
 *
 * Logik:
 * - Kein Key in localStorage (bestehender User, erstes Mal mit Feature): Modal anzeigen.
 * - Key vorhanden, aber ältere Version: Modal anzeigen (neues Update).
 * - Version bereits gesehen (Key === APP_VERSION): Nichts tun.
 */
export function useChangelog() {
  const [showChangelog, setShowChangelog] = useState(false);

  useEffect(() => {
    const seenVersion = localStorage.getItem(STORAGE_KEY);

    if (seenVersion !== APP_VERSION) {
      // Noch nicht gesehen (kein Key oder ältere Version): Modal anzeigen
      setShowChangelog(true);
    }
  }, []);

  const dismissChangelog = () => {
    localStorage.setItem(STORAGE_KEY, APP_VERSION);
    setShowChangelog(false);
  };

  return { showChangelog, dismissChangelog };
}
